


















































































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import wxTextEdit from "../tenantsView/wx-message_TextEdit.vue"; //文本回复表单
import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import httpApi from "@/API/Tenant/Weixin";
import { format } from "path";
 
//import App from "@/components/Global/GetAppData"; //缓存接口
import { log } from "util";
import { WXText } from "@/Entity"; //全局常量
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
import Bus from "@/JS/Bus";
@Component({
  components: { wxTextEdit }
})
export default class extends Vue {
  $message: any;
  //注入数据 @Provide()
  @Provide()
  private pagesize = 10; //每页的数据条数
  private pageIndex = 1; // 默认第一页
  private totalItem = 0; //数据总长度
  private Keyword = ""; //搜索
  private Data = {}; //把行信息传到子组件
  private TextTabData = []; //表格
  private TextEdit = true; //父子组件的显示和隐藏
  private State:string=""; //状态
  private scrollHeight = 500; //当前高度
  private GetAppData:any = [];
  //分页方法
  private handleClick() {}
  private handleSizeChange(val: any) {
    this.pagesize = val;
    this.getTextList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = val;
    this.getTextList();
  }
  //格式化状态
  formatState(row: any, column: any) {
    switch (row.State) {
      case 1:
        return "启用";
      case 0:
        return "禁用";
      case -1:
        return "删除";
    }
  }
  //格式化时间
  formatDate(row: any, column: any) {
    if (row.UpdaterDate != null && row.UpdaterDate != "") {
      var date = row.UpdaterDate;
      date = date.replace("T", " ");
      date = date.substring(0, 16);
      return date;
    } else {
      return "";
    }
  }

  //格式化匹配度类型
  formatStatus(row: any, column: any) {
    switch (row.Type) {
      case 0:
        return "包含匹配";
      case 1:
        return "完全匹配";
      default:
        return "";
    }
  }

  //查询方法
  Inquire() {
    this.getTextList();
  }
  //表单过来的刷新方法
  refresh() {
    this.getTextList();
    this.TextEdit = true;
  }
  //初始化
  created() {
    let Aid = getCookie("Aid");
    let TenantID = getCookie("TenantID");   
    this.GetAppData = {
      Aid: Aid,
      TenantID: TenantID
    };
     var that = this;
    Bus.$off("switchAccountFn");
    Bus.$on("switchAccountFn", (obj:any) => {
      that.GetAppData.Aid=obj.Aid;    
      that.getTextList();  
    });
    //   this.GetAppData= JSON.parse(Utils.decrypt(CookieData, ""));
    //   console.log(this.GetAppData);
    // setCookie("Aid",  Utils.encrypt(info.Aid,""), expireDays); //
    // setCookie("TenantID",  Utils.encrypt(info.TenantID,""), expireDays); //
    this.getTextList();
    this.scrollHeight = document.body.scrollHeight - 440;
  }
  //编辑
  handleEdit(index: any, row: any) {
    this.Data = row; //把行信息传给data
    this.TextEdit = false;
  }
  //新增文本方法
  AddTextEdit() {
    this.TextEdit = false;
    this.Data = new WXText();
  }
  //加载表格数据
  //加载数据
  async getTextList() {
    var _this = this;
    //console.log(this.GetAppData);
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      //搜索的数据 传参
      let params: any = {
        Input: [
          { Name: "Aid", value: AppAccount.Aid },
          //分页参数
          { Name: "page", value: this.pageIndex },
          { Name: "rows", value: this.pagesize }
        ]
      };
      if (this.State) {
        params.Input.push({ Name: "State", value: this.State });
      }
      //console.log(params);
      var res: any = await httpApi.GetWxText(params);
      if (res.ErrorCode == 0) {
        _this.TextTabData = res.output[0].value;
        //前端搜索
        if (_this.Keyword) {
          _this.TextTabData = res.output[0].value.filter(
            (x: {
              Keyword: {
                toUpperCase: () => { indexOf: (arg0: string) => number };
              };
            }) =>
              x.Keyword.toUpperCase().indexOf(
                _this.Keyword.trim().toUpperCase()
              ) != -1
          );
        }
        _this.totalItem = _this.TextTabData.length;
      } else {
        this.$message.error(res.ErrorMessage);
      }
    }
  }

  //单行删除
  async handleDel(index: any, row: any) {
    this.$confirm("确定要删除当前数据吗?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      let model = row as WXText; //把行内信息转换成wxText
      var _this = this;
      let AppAccount = this.GetAppData;

      if (AppAccount) {
        model.ApplicationId = AppAccount.Aid;
        model.TenantId = AppAccount.TenantID;
        model.ActionName = "DELETE";
        let params: any = {
          Input: [
            {
              Name: "AppReplyTextDTO",
              value: model
            }
          ]
        };
        var res: any = await httpApi.SaveWxText(params);
        if (res.ErrorCode == 0) {
          this.$message.success("删除成功!");
          this.getTextList();
        } else {
          this.$message.error("删除失败：" + res.ErrorMessage);
        }
      }

      return new WXText();
    });
  }
}
